import {map} from 'lodash';
import {useEffect, useState} from 'react';
import Highcharts from 'highcharts/highstock';
import {Box, Typography} from '@mui/material';
import Mapka from './assets/mapka-port-gdynia-halas-new.png';
import DeviceMarker from './components/DeviceMarker/DeviceMarker';
import NoiseChart from './components/NoiseChart/NoiseChart';
import {BASE_URL, PORT_GDYNIA_MAIN_COLOR} from './utils';
import 'moment/locale/pl';

const devicesNames = {
  'GDY_00': '11 - Ul. Rotterdamska 13',
  'GDY20180803320001': '1 - Kapitanat',
  'GDY20180803320002': '2 - Ul. Chrzanowskiego',
  'GDY20180803320003': '3 - Ul. Węglowa',
  'GDY20180803320004': '4 - Nauta',
  'GDY20180803320005': '5 - Dalmor',
  'GDY20181103320006': '6 - Bunkier',
  'GDY_07': '7 - Nab. Indyjskie',
  'GDY_NOISE_01': '8 - BCT',
  'GDY_NOISE_02': '9 - BCT',
  'GDY_NOISE_03': '10 - BCT',
};

const devices = [
  {serialNo: 'GDY_00', name: '11 - Ul. Rotterdamska 13', left: 530, top: 520, marginTop: -8, marginLeft: -9, labelLeft: -340, labelTop: -50},
  {serialNo: 'GDY20180803320001', name: '1 - Muzeum Emigracji', left: 550 + 279, top: 345 + 85 - 30, marginTop: -8, marginLeft: -9,labelLeft: 30, labelTop: -170},
  {serialNo: 'GDY20180803320002', name: '2 - Ul. Chrzanowskiego', left: 500 + 268, top: 390 + 95, marginTop: -4, marginLeft: 5,labelLeft: 30, labelTop: -170},
  {serialNo: 'GDY20180803320003', name: '3 - Ul. Węglowa', left: 545 + 276 - 10, top: 425 + 115, marginTop: -4, marginLeft: 1,labelLeft: 50, labelTop: -170},
  {serialNo: 'GDY20180803320004', name: '4 - Nauta', left: 560 + 285, top: 500 + 135, marginTop: 0, marginLeft: -10,labelLeft: -360, labelTop: -80},
  {serialNo: 'GDY20180803320005', name: '5 - Dalmor', left: 627 + 305, top: 486 + 130, marginTop: 0, marginLeft: -10,labelLeft: 40, labelTop: -60},
  {serialNo: 'GDY20181103320006', name: '6 - Bunkier', left: 460 + 255, top: 385 + 100, marginTop: 0, marginLeft: -10,labelLeft: -340, labelTop: -150},
  {serialNo: 'GDY_07', name: '7 - Nab. Indyjskie', left: 690, top: 398, marginTop: -8, marginLeft: -9, labelLeft: -340, labelTop: -110},
  {serialNo: 'GDY_NOISE_03', name: '10 - BCT', left: 195 + 168, top: 100 + 7, marginTop: 0, marginLeft: -9,labelLeft: 40, labelTop: 20},
  {serialNo: 'GDY_NOISE_02', name: '9 - BCT', left: 120 + 144, top: 75 - 2, marginTop: 0, marginLeft: -10,labelLeft: 40, labelTop: 10},
  {serialNo: 'GDY_NOISE_01', name: '8 - BCT', left: 65 + 124, top: 52 - 4, marginTop: -8, marginLeft: -10,labelLeft: 40, labelTop: 10},

];

const seriesData = (measurementData) => map(measurementData, (data, serialNo) => {
  return ({
    name: devicesNames[serialNo],
    data: data,
  });
});
// const serials = ['GDY_00', 'GDY20180803320001', 'GDY20180803320002', 'GDY20180803320003', 'GDY20180803320004', 'GDY20180803320005', 'GDY20181103320006', 'GDY_07', 'GDY_NOISE_01', 'GDY_NOISE_02', 'GDY_NOISE_03'];
const serials = ['GDY_00', 'GDY20180803320001', 'GDY20180803320002', 'GDY20180803320003', 'GDY20180803320004',  'GDY20180803320005', 'GDY20181103320006', 'GDY_07', 'GDY_NOISE_01', 'GDY_NOISE_02', 'GDY_NOISE_03'];

const PUBLIC_DATA_7d = `${BASE_URL}/history/gdy/7d?m=noise&serialNo=${serials}`;
const PUBLIC_DATA_3d = `${BASE_URL}/history/gdy/3d?m=noise&serialNo=${serials}`;
const PUBLIC_DATA_LAST_NOISE = `${BASE_URL}/last/gdy/${serials}?m=noise`;


function GDY_NOISE_App() {
  const [selectedDevice, setSelectedDevice] = useState(null);
  const [data7d, setData7d] = useState({});
  const [data3d, setData3d] = useState({});
  const [dataLast, setDataLast] = useState({});
  const en = window.location.href.includes('lang=en');

  useEffect(() => {
    if (!window.location.href.includes('lang=en')) {
      Highcharts.setOptions({
        lang: {
          loading: 'Pobieram dane...',
          shortMonths: [
            'Styczeń', 'Luty', 'Marzec', 'Kwiecień',
            'Maj', 'Czerwiec', 'Lipiec', 'Sierpień',
            'Wrzesień', 'Październik', 'Listopad', 'Grudzień'
          ],
          months: [
            'Styczeń', 'Luty', 'Marzec', 'Kwiecień',
            'Maj', 'Czerwiec', 'Lipiec', 'Sierpień',
            'Wrzesień', 'Październik', 'Listopad', 'Grudzień'
          ],
          weekdays: [
            'Niedziela', 'Pon.', 'Wtorek', 'Środa', 'Czwartek',
            'Piątek', 'Sobota', 'Niedziela'
          ]
        }
      });
    }
    fetch(PUBLIC_DATA_LAST_NOISE).then(response => {
      response.json().then(result => setDataLast(result));
    }).catch(error => console.error(error));
    fetch(PUBLIC_DATA_3d).then(response => {
      response.json().then(result => setData3d(result));
    }).catch(error => console.error(error));
    fetch(PUBLIC_DATA_7d).then(response => {
      response.json().then(result => setData7d(result));
    }).catch(error => console.error(error));

  }, []);

  const safeReadValue = (serialNo, m) => {
    if (dataLast[serialNo] && dataLast[serialNo][m]) {
      return dataLast[serialNo][m][1];
    } else {
      return null;
    }
  };
  const safeReadTime = (serialNo, m) => {
    if (dataLast[serialNo] && dataLast[serialNo][m]) {
      return dataLast[serialNo][m][0];
    } else {
      return new Date().getTime();
    }
  };

  const onDeviceClick = serialNo => setSelectedDevice(serialNo);

  return (
    <Box textAlign={'center'}>
      <Typography
        color={PORT_GDYNIA_MAIN_COLOR}
        fontWeight={'bold'}
        variant={'h5'}>{en ? 'Noise monitoring points' : 'Punkty monitoringu natężenia hałasu'}</Typography>
      <br/><br/>

      <Box mb={10} display={'flex'} flexWrap={'wrap'} alignItems={'center'} justifyContent={'center'}>

        <Box position={'relative'} width={1380} height={725} sx={{backgroundImage: `url(${Mapka})`}}>
          {devices.map(d =>
            <DeviceMarker
              key={d.serialNo}
              noise={safeReadValue(d.serialNo, 'noise')}
              timestamp={safeReadTime(d.serialNo, 'noise')}

              label={devicesNames[d.serialNo]}
              marginTop={d.marginTop}
              marginLeft={d.marginLeft}
              left={d.left}
              top={d.top}
              labelLeft={d.labelLeft}
              labelTop={d.labelTop}
              onClick={() => onDeviceClick(d.serialNo)}
            />
          )}
        </Box>
      </Box>

      <br/><br/>

      <NoiseChart title={en ? 'Noise level (1h) - Last 3 days' : 'Poziom hałasu (1h) - Ostatnie 3 dni'}
                  seriesList={seriesData(data3d.noise)}/>
      <br/><br/>
      <hr/>
      <NoiseChart columns
                  title={en ? 'Noise level (daily avg) - Last 7 days' : 'Poziom hałasu (śr. dobowe) - Ostatnie 7 dni'}
                  seriesList={seriesData(data7d.noise)}/>
      <br/><br/>
      <hr/>

    </Box>
  );
}

export default GDY_NOISE_App;
